import { Box } from '@careguide/theme'
import Text from 'components/base/Text'

import { Recommender } from 'types/recommendations'
import { Image } from 'components/generic/HomePageComponents'

type RecommendationProps = {
  recommender: Recommender
  listingOwnerName: string
  siteKeyword: string
}

const Recommendation = ({ recommender, listingOwnerName, siteKeyword }: RecommendationProps) => {
  const avatarUrl = recommender?.avatarUrl
  const firstName = recommender?.firstName
  const lastName = recommender?.lastName
  const message = recommender?.message || 'I recommend ' + listingOwnerName + ' as a ' + siteKeyword

  return (
    <Box display='flex' pb={4} role='listitem'>
      <Image
        width={32}
        pt={2}
        borderRadius='50%'
        src={avatarUrl}
        alignSelf='flex-start'
        aria-hidden
      />
      <Box display='flex' flexDirection='column'>
        <Text as='h4' mt={2} mb={0} pl={2} fontWeight='bold'>
          {`${firstName} ${lastName}`}
        </Text>
        <Text as='p' mt={2} mb={2} pl={2}>
          {message}
        </Text>
      </Box>
    </Box>
  )
}

export default Recommendation
